import { render, staticRenderFns } from "./VoucherListItem.vue?vue&type=template&id=4f573cd4&"
import script from "./VoucherListItem.vue?vue&type=script&lang=js&"
export * from "./VoucherListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports